module.exports = __webpack_public_path__ + "static/media/tumble5.8b5fdcae.jpg";